import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flexDirection"];
import { LayoutFlex } from './LayoutFlex';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutVertical = _ref => {
  let {
      children,
      flexDirection = 'column'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(LayoutFlex, Object.assign({}, rest, {
    flexDirection: flexDirection,
    children: children
  }));
};